var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-icon",class:_vm.iconClass,style:([
        _vm.width ? { width: _vm.width } : {},
        _vm.height ? { height: _vm.height } : {}
    ])},[_c(`Icon${_vm.icon}`,_vm._b({tag:"component"},'component',{ ..._vm.$props, ..._vm.iconConfig },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }